var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [
        _vm._v(
          _vm._s(_vm.$translate("Ceres::Template.itemEuResponsiblePersonTitle"))
        )
      ]),
      _vm._v(" "),
      _vm.manufacturer && _vm.isEuResponsibleTabShown
        ? [
            _vm.concatenatedNames
              ? _c("div", { staticClass: "mb-2" }, [
                  _c("b", [_vm._v(_vm._s(_vm.concatenatedNames))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFieldsEu.includes("EUname")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [_vm._v(_vm._s(_vm.manufacturer.responsibleName))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "p-0" }, [
              _vm.visibleFieldsEu.includes("EUstreet")
                ? _c("span", [
                    _vm._v(_vm._s(_vm.manufacturer.responsibleStreet))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleFieldsEu.includes("EUhouseNr")
                ? _c("span", [
                    _vm._v(_vm._s(_vm.manufacturer.responsibleHouseNo))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-0" }, [
              _vm.visibleFieldsEu.includes("EUzipcode")
                ? _c("span", [
                    _vm._v(_vm._s(_vm.manufacturer.responsiblePostCode))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleFieldsEu.includes("EUcity")
                ? _c("span", [_vm._v(_vm._s(_vm.manufacturer.responsibleTown))])
                : _vm._e(),
              _vm._v(" "),
              _vm.manufacturer.responsibleCountryObject &&
              _vm.visibleFieldsEu.includes("EUcountry")
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.manufacturer.responsibleCountryObject.name) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.visibleFieldsEu.includes("EUmail")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.manufacturer.responsibleEmail))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFieldsEu.includes("EUphone")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.manufacturer.responsiblePhoneNo))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleFieldsEu.includes("EUcontactForm")
              ? _c("div", { staticClass: "p-0" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.manufacturer.responsibleContactUrl))
                  ])
                ])
              : _vm._e()
          ]
        : [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$translate(
                    "Ceres::Template.itemEuResponsibleNoInformation"
                  )
                ) +
                "\n  "
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }